import React, { useRef, useState, useEffect, useCallback } from 'react';
import { classNames } from 'primereact/utils';
import { useHistory } from "react-router-dom";
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Skeleton } from 'primereact/skeleton';
import { BrCalendar } from './BrCalendar';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { ErrorValidationMessage } from './ErrorValidationMessage';

import api from '../api/api';

import '../layout/sass/_form.scss';
import { Dropdown } from 'primereact/dropdown';
import { TabelaLojaItens } from './TabelaLojaItens';
import { FormLojaItens } from './FormLojaItens';

export const FormLoja = ({ isEditing, isLoading, defaultValues }) => {
    
    const [lojistas, setLojistas] = useState([]);
    const [lojaItens, setLojaItens] = useState([]);
    const [produtos, setProdutos] = useState([]);
    const [showFormLoja, setShowFormLoja] = useState(false);
    const history = useHistory();
    const toast = useRef(null);
    const [isSubmiting, setIsSubmiting] = useState(false)
    
    const schema = Yup.object().shape({
        lojistaId: Yup
            .number()
            .nullable()
            .required("O lojista é obrigatório"),
        dataEmissao: Yup
            .string()
            .nullable()
            .required("A data de emissão é obrigatória"),          
    })

    const formik = useFormik({

        initialValues: defaultValues,

        validationSchema: schema,

        enableReinitialize: true,

        onSubmit: async (data) => {
            setIsSubmiting(true)     
            
            try {
                if (!isEditing) {
                    const tempLojaItens = lojaItens.map((item) => {
                        return ({
                            "produtoId": item.produtoId,
                            "quantidade": item.quantidade,
                            "municipioId": item.municipioId,
                        }
                        )
        
                    })
                    data.itens = tempLojaItens
                    if (data.itens.length !== 0)
                    {
                        await api.post("loja", data)
    
                        formik.resetForm()
                        toast.current.show({ life: 2000, severity: 'success', summary: 'Cadastro concluído!', detail: `Loja adicionada com sucesso` });
                        setTimeout(async () => {
                            history.push('/loja')
    
                        }, 2000)
                    }
                    else
                    {
                        toast.current.show({ life: 3000, severity: 'error', summary: 'Produto(s) não adicionado(s)!', detail: `É obrigatório adicionar ao menos um produto.` });
                    }

                }
                else {
                    await api.put("loja", data)
                    
                    toast.current.show({ life: 2000, severity: 'success', summary: 'Cadastro atualizado!', detail: `Loja atualizada com sucesso` });
                    setTimeout(() => {
                        
                        history.push('/loja')

                    }, 2000)
                }
            }
            catch (error) {
                if (!isEditing)
                    toast.current.show({ life: 2000, severity: 'error', summary: 'Erro ao cadastrar loja!', detail: error.toString() });
                else
                    toast.current.show({ life: 2000, severity: 'error', summary: 'Erro ao editar loja!', detail: error.toString() });

            }

            setIsSubmiting(false)
        }
    })

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);

    const getLojistas = useCallback(async () => {
        try {
            const response = await api.get(`pessoa/lojistas`);
            setLojistas(response.data)
        }
        catch (error) {
            toast.current.show({ severity: 'error', summary: 'Erro ao obter lojistas', detail: error.toString() });
        }
    }, []);

    const getLojaItens = useCallback(async () => {
        try {
            if (formik.values.id)
            {
                const response = await api.get(`loja/${formik.values.id}`);
                const itens = response.data.itens.map((i) => { 
                    return { 
                        // eslint-disable-next-line no-dupe-keys
                        id: i.produtoId, produtoNome: i.produtoNome + ' - ' + i.produtoEmbalagem, id: i.id, quantidade: i.quantidade, municipioNome: i.municipioNome 
                        }
                });
                
                setLojaItens(itens)
            }
            const response = await api.get(`produto/produtosAll`);

            setProdutos(response.data.map(i => {
                var prod = {label: '', value: ''};
                prod.label = i.nome + " - " + i.embalagem
                prod.value = i.id 
                return prod
            }));
        }
        catch (error) {
            toast.current.show({ severity: 'error', summary: 'Erro ao obter lojistas', detail: error.toString() });
        }
    }, [formik.values.id]);

    useEffect(() => {

        async function loja() {
            await getLojistas();
            await getLojaItens();
        };
        loja();
    }, [getLojistas, getLojaItens])

    return (
        <>
        <div className="card p-grid p-col-12 p-mx-0 p-mt-0">
            <Toast ref={toast} position="bottom-right" />
            <div className="p-col-12">
                <h2 className="p-mt-0">Loja</h2>
                <form onSubmit={formik.handleSubmit}>
                    <div className="p-formgrid p-grid p-fluid p-mx-0">
                    <div className="p-field p-col-12 p-sm-4">
                            <label
                                htmlFor="lojistaId"
                                className={classNames({ 'p-error': isFormFieldValid('matriculaId') })}
                            >
                                Lojista
                            </label>
                            {
                                !isLoading ?
                                <Dropdown
                                    id="lojistaId"
                                    name="lojistaId"
                                    options={lojistas}
                                    optionValue='id'
                                    optionLabel='nome'
                                    emptyMessage="Nenhum lojista encontrado"
                                    emptyFilterMessage={"Nenhum lojista encontrado"}
                                    filter={true}
                                    value={formik.values.lojistaId}
                                    onChange={(e) => formik.setFieldValue("lojistaId", e.value)}
                                    className={classNames({ 'p-invalid': isFormFieldValid('lojistaId') })}
                                    placeholder="Selecione um lojista"
                                    showClear={true} 
                                />  
                                    :
                                    <Skeleton height="35px" />
                            }
                            {formik.errors.lojistaId && formik.touched.lojistaId &&
                                <ErrorValidationMessage message={formik.errors.lojistaId} />
                            }
                        </div>

                        <div className="p-field p-col-12 p-sm-4 p-md-4">
                                <label
                                    htmlFor="dataEmissao"
                                    className={classNames({ 'p-error': isFormFieldValid('dataEmissao') })}
                                >
                                    Data Emissão
                                </label>
                                <BrCalendar
                                    id="dataEmissao"
                                    name="dataEmissao"
                                    value={formik.values.dataEmissao}
                                    onChange={formik.handleChange}
                                    placeholder={ isEditing ? new Date(formik.values.dataEmissao).toLocaleDateString('pt-BR') : "" }
                                    className={classNames({ 'p-invalid': isFormFieldValid('dataEmissao') })}
                                    yearRange={`2000:${new Date().getFullYear() + 2}`}
                                    disabledDays="none"
                                />
                                {formik.errors.dataEmissao && formik.touched.dataEmissao &&
                                    <ErrorValidationMessage message={formik.errors.dataEmissao} />
                                }
                        </div>

                    </div>

                    {!isEditing ?
                        <FormLojaItens
                            visible={showFormLoja}
                            setVisible={setShowFormLoja}
                            lojaItens={lojaItens} 
                            setLojaItens={setLojaItens}
                            produtos={produtos}
                        />
                        : <></>
                    }

                    <div className="p-d-flex p-jc-end p-mr-1" id="LojaItens" >

                        <TabelaLojaItens lojaItens={lojaItens} setLojaItens={setLojaItens} isEditing={isEditing} getLojaItens={getLojaItens} defaultValues={defaultValues}/>

                    </div>

                    <div className="p-d-flex p-jc-end p-mr-1">
                        {
                            !isLoading ?
                                <Button
                                    label={isEditing ? 'Atualizar' : 'Salvar'}
                                    type="submit"
                                    iconPos="right"
                                    loading={isSubmiting}
                                />
                                :
                                <Skeleton width="82.16px" height="35px" />

                        }
                    </div>
                </form>
            </div>
        </div>
        
    </>
    );
}